const stepperDown = {
    svg: '<svg style="width:1.00rem; height:0.75rem;" viewBox="0 0 16 12"><polygon points="4.5 2.25 8 5.75 11.5 2.25"/></svg>',
};

export { stepperDown as default };
